const convertTime = (minutes: number | null) => {
  if (!minutes) {
    return { time: '--', unit: 'mins' };
  }
  if (minutes < 1 && minutes > 0) {
    return { time: '< 1', unit: 'min' };
  }
  if (minutes < 60 && minutes >= 1) {
    return {
      time: Math.round(minutes),
      unit: Math.round(minutes) === 1 ? 'min' : 'mins'
    };
  }
  if (minutes < 1440) {
    const totalHours = minutes / 60;
    const roundedHours = Math.round(totalHours);
    return {
      time: roundedHours,
      unit: roundedHours === 1 ? 'hour' : 'hours'
    };
  }
  const totalDays = minutes / 1440;
  const roundedDays = Math.round(totalDays);
  return { time: roundedDays, unit: roundedDays === 1 ? 'day' : 'days' };
};

export default convertTime;
